// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title {
    display:inline-block; 
    padding: 10px 20px 10px 20px;
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
    border-radius: 10px;
    font-size: large;
    font-size: 25px;
    font-weight: 600;
    font-family: "Copperplate";
}

.content {
    /* background-color: rgba(19, 8, 8, 0.01); */
    border-radius: 10px;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
}

.top-line-btn {
    height: 100%;
    border-radius: 40px;
    margin-right:10px;
    margin-left: 10px;
    color: black
}

.top-line-btn:focus {
    outline: none;
}


.edit-btn {
    background-color: #a4daf5;
    box-shadow: #076fe6 0px 2px 4px,
}
.edit-btn:hover {
    background-color:#076fe6;
}

.delete-btn {
    background-color: #f5a9ae;
    box-shadow: #f76a74 0px 2px 4px,;
}

.delete-btn:hover {
    background-color: #f76a74;
}


.dropzone-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
  }
  
  .dropzone {
    width: 40%;
    min-width: 250px;
    cursor: pointer;
    /* height: 220px; */
    padding: 1rem;
    text-align: center;
    border-radius: 20px;
    border: dashed 1px #979797;
    position: relative;
    margin: 0 auto;
    box-shadow: 1px 1px 2px rgba(255, 255, 255, .6)
  }
  
  
  
  
  .dropzone input {
    opacity: 0;
    position: absolute;
    z-index: 2;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    cursor: pointer;
  }
  
  ul {
    padding: 0px;
    margin: 0px;
  }
  
  .dropzone label {
    color: white;
    background-image: linear-gradient(to right, #77A1D3, #79CBCA );
    height: 32px;
    width: 150px;
    border-radius: 20px;
    padding: 4px 8px;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 2px 0px;
  }
  
  .dropzone h5 {
    color: #aaabad;
    font-weight: 700;
  }
  

.document-container {
    margin-top: 30px;
    background-color: rgba(19, 8, 8, 0.01);
    border-radius: 10px;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
    padding: 10px;
    margin-bottom: 30px;
}

.document-title {
    margin-left: 10px;
    font-size: 20px;
    font-weight: 600;
    color: black;
    font-family: "Copperplate";
}

.file-list {
    width: 75%;
    display: flex;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
    border-radius: 10px;
    font-size: 10px;
    color: black
}

.info {
    width: 90%
}

.name {
    font-size: 14px;
    font-weight: 500;
    color: #353f4a;
    margin: 0;
}

.dropzone-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 50%;
    margin-top: 20px;
}

.center {
    display: flex; 
    justify-content: center;
    align-items: center;
}

.list-document-container {
    display: flex;
    flex-direction: row;
    width: 100%;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-items: center;
}

.document-item-container {
    margin: 0px; 
    padding: 10px;
    border-radius: 10px;
    background-color: white;
    width: 40%; 
    display: flex; 
    justify-content: space-between;
    flex-direction: row;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
    margin-bottom: 10px;
}

.edit-button {
    border-radius: 15px;
    background: #F2F2F2;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px;
}`, "",{"version":3,"sources":["webpack://./src/app/help-content/help-content.component.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,4BAA4B;IAC5B,4EAA4E;IAC5E,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,4CAA4C;IAC5C,mBAAmB;IACnB,wFAAwF;AAC5F;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,yBAAyB;IACzB;AACJ;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,0BAA0B;IAC1B,kBAAkB;IAClB,cAAc;IACd;EACF;;;;;EAKA;IACE,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,8DAA8D;IAC9D,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,iDAAiD;EACnD;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;;AAGF;IACI,gBAAgB;IAChB,sCAAsC;IACtC,mBAAmB;IACnB,wFAAwF;IACxF,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,UAAU;IACV,aAAa;IACb,iDAAiD;IACjD,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,wFAAwF;IACxF,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,0CAA0C;AAC9C","sourcesContent":[".title {\n    display:inline-block; \n    padding: 10px 20px 10px 20px;\n    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;\n    border-radius: 10px;\n    font-size: large;\n    font-size: 25px;\n    font-weight: 600;\n    font-family: \"Copperplate\";\n}\n\n.content {\n    /* background-color: rgba(19, 8, 8, 0.01); */\n    border-radius: 10px;\n    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;\n}\n\n.top-line-btn {\n    height: 100%;\n    border-radius: 40px;\n    margin-right:10px;\n    margin-left: 10px;\n    color: black\n}\n\n.top-line-btn:focus {\n    outline: none;\n}\n\n\n.edit-btn {\n    background-color: #a4daf5;\n    box-shadow: #076fe6 0px 2px 4px,\n}\n.edit-btn:hover {\n    background-color:#076fe6;\n}\n\n.delete-btn {\n    background-color: #f5a9ae;\n    box-shadow: #f76a74 0px 2px 4px,;\n}\n\n.delete-btn:hover {\n    background-color: #f76a74;\n}\n\n\n.dropzone-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    width: 100%;\n  }\n  \n  .dropzone {\n    width: 40%;\n    min-width: 250px;\n    cursor: pointer;\n    /* height: 220px; */\n    padding: 1rem;\n    text-align: center;\n    border-radius: 20px;\n    border: dashed 1px #979797;\n    position: relative;\n    margin: 0 auto;\n    box-shadow: 1px 1px 2px rgba(255, 255, 255, .6)\n  }\n  \n  \n  \n  \n  .dropzone input {\n    opacity: 0;\n    position: absolute;\n    z-index: 2;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    cursor: pointer;\n  }\n  \n  ul {\n    padding: 0px;\n    margin: 0px;\n  }\n  \n  .dropzone label {\n    color: white;\n    background-image: linear-gradient(to right, #77A1D3, #79CBCA );\n    height: 32px;\n    width: 150px;\n    border-radius: 20px;\n    padding: 4px 8px;\n    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 2px 0px;\n  }\n  \n  .dropzone h5 {\n    color: #aaabad;\n    font-weight: 700;\n  }\n  \n\n.document-container {\n    margin-top: 30px;\n    background-color: rgba(19, 8, 8, 0.01);\n    border-radius: 10px;\n    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;\n    padding: 10px;\n    margin-bottom: 30px;\n}\n\n.document-title {\n    margin-left: 10px;\n    font-size: 20px;\n    font-weight: 600;\n    color: black;\n    font-family: \"Copperplate\";\n}\n\n.file-list {\n    width: 75%;\n    display: flex;\n    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    margin-top: 15px;\n    border-radius: 10px;\n    font-size: 10px;\n    color: black\n}\n\n.info {\n    width: 90%\n}\n\n.name {\n    font-size: 14px;\n    font-weight: 500;\n    color: #353f4a;\n    margin: 0;\n}\n\n.dropzone-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    width: 50%;\n    margin-top: 20px;\n}\n\n.center {\n    display: flex; \n    justify-content: center;\n    align-items: center;\n}\n\n.list-document-container {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    flex-wrap: wrap;\n    justify-content: space-evenly;\n    align-items: center;\n}\n\n.document-item-container {\n    margin: 0px; \n    padding: 10px;\n    border-radius: 10px;\n    background-color: white;\n    width: 40%; \n    display: flex; \n    justify-content: space-between;\n    flex-direction: row;\n    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;\n    margin-bottom: 10px;\n}\n\n.edit-button {\n    border-radius: 15px;\n    background: #F2F2F2;\n    box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
